import React, {Component} from 'react';
import {
		CardElement,
		injectStripe
		// PaymentRequestButtonElement
		} from 'react-stripe-elements';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import { connect } from 'react-redux';
import Responsive from 'react-responsive';
import { renderTimestamp,not_logged_DiscountCodeLog_decide,isValidEmail,animateScroll, isJSON } from '../../utils/util';
import Api from '../../utils/api';
import { stateData } from '../../data/states';
import {RESPONSE_STATUS } from '../../utils/constants';
import { Loader } from 'semantic-ui-react'
import RecommendationsProduct from './RecommendationsProduct';
import RecommendationsCartItem from './RecommendationCartItem'
import {getUserCartData,addOrDeleteCartGoodsData,fun_deleteAllCartGoodsData } from '../../actions/cartAction';
import "./RecommendationsCheckout.css"


class RecommendationsCheckout extends Component {
	constructor(props) {
		super(props);

		this.idempotencyKey = Api.getUUID();
       
		this.handleSubmit = this.handleSubmit.bind(this);
        this.checkIfPromoCodeExists = this.checkIfPromoCodeExists.bind(this);
        this.handleCheckChangeShippingAddress = this.handleCheckChangeShippingAddress.bind(this);
        this.getCardDigits = this.getCardDigits.bind(this);
        this.getShippingAddress = this.getShippingAddress.bind(this);

		const paymentRequest = this.props.stripe.paymentRequest({
			country: 'US',
			currency: 'usd',
			total: {
				label: 'Gate Fee',
				amount: 1000
			},
		});

		paymentRequest.on('token', ({complete, token, ...data}) => {
			// this.handlePayment(token);
			complete('success');
		});
		paymentRequest.canMakePayment().then((result) => this.setState({ showPaymentRequestButton: !!result }));

	    this.state = {
            stepOneStep: 0,
            stepTwoStep: 0,
            showThankYou: false,
            phoneNumber: '',
            confirmCode: null,
            budget: null,
            isEditingProducts: false,
            inputValue: null,
            productTypes: [],
            defaultPurchaseConfirmed: false,
            codeMatch: true,
            paymentRequest: paymentRequest,
            showPaymentRequestButton: false,
            country: '',
            region: '',
            fnameShipping: '',
            lnameShipping: '',
            addressOneShipping: '',
            addressTwoShipping: '',
            cityShipping: '',
            zipShipping: '',
            firstName: '',
            lastName: '',
            addressOne: '',
            addressTwo: '',
            city: '',
            zip: '',
            disablePurchaseButton: true,
            disableBillingButton: false,
            disableShippingButton: false,
            showShippingAddressSection: false,
            promoCode: '',
            promoCodeSaved: '',
            amountAvailableForDiscount: 0,
            discountType: '',
            discountExpirationDate: '',
            showPromoSuccessMessage: false,
            promoCodeError: '',
            useExistingCard: true,
            discountCodes: [],
            card: {
                cardDigits: '',
                cardBrand: ''
            },
            shippingAddressName: '',
            shippingAddressStr: '',
            updateShippingAddressFromBilling: false,
            shippingRate: 0,
            tax: 0,
            productsArr: [],
            price: props.price,
            addedToCart: false,
            productsAddElementBrakeBias:0,
            arrowLeftDisabled: '-disabled',
            arrowRightDisabled: '',
            quickAddGoodsData: [],
            discountPrice: 0,
            isShowPaymentConten: false,
            isShowShippingConten:false,
            isCheckoutButton: false,
            discountCodeData:'',
            isEntitlePrice:0,
            contactInformation_email:'',
            contactInformation_lastName:'',
            contactInformation_firstName:'',
            isShowContactInformation:true,
            stripeToken:'',
            targetType:'',
            isApplyButton:false,
            isEntitle:[],
        }
	}

    componentDidMount() {
        
        this.getCardDigits();
        if(localStorage.getItem("auth_token")){
            this.props.getUserCartData();
        }else{
            this.setState({isShowPaymentConten:true});
        }        
        this.getShippingAddress();
        this.getQuickAddProducts();
        this.fun_setcontactInfoMatino_info();
        

        this.setState({ productsArr: this.props.productArr ? this.props.productArr : []});
        var _this =this;
        setTimeout(function(){
            _this.setState({
                disablePurchaseButton:false
            })
        },1000);
        // 用户信息没缓存起来，就重新获取下
        if(!localStorage.getItem("user_account_info") && localStorage.getItem("auth_token")){
            this.getGenderId()
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.country !== this.state.country) {
            this.setState({ region: "" });
        }

        if (prevState.countryShipping !== this.state.countryShipping) {
            this.setState({ regionShipping: "" });
        }

        if (prevProps.productArr !== this.props.productArr) {
            this.setState({ productsArr: this.props.productArr });
        }

        if (prevProps.price !== this.props.price) {
            this.setState({ price: this.props.price }, ()=> {
                this.getShippingAddress()
                // this.calculateShipping()
            });
        }
    }
    
    componentWillUnmount() {
        if (!window.location.pathname.includes("/products/")) this.props.forceRender();
    }
    
    getCardDigits() {
        if(localStorage.getItem("auth_token") ){
            const userId = localStorage.getItem("user_id");
            const url = '/api/stripe/card?user-id=';
            fetch(url + userId, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-auth-token': Api.auth_tokenManager()
                }
            }).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    this.setState({
                        isShowPaymentConten:true
                    })
                }
            }).then(responseJson => {
                this.setState({
                    card: {
                        cardDigits: responseJson.last4,
                        cardBrand: responseJson.brand
                    }
                });
            }).catch(function(err) {
                console.log("Please input your credit card information and address on cart page before proceeding.");
            });
        }else{

        }
        
    }

    getShippingAddress() {
        var _this = this;
        if(localStorage.getItem("auth_token") ){
            const userId = localStorage.getItem("user_id");
            const url = '/api/shipping-addresses?user-id=';
            fetch(url + userId, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-auth-token': Api.auth_tokenManager()
                }
            }).then((response) => {
                if (response.status >= 200 && response.status < 300) {
    
                    return response.json();
                } else {
                    console.log("No info");
                }
                
            }).then(responseJson => {
                const shippingAddressName = `${ responseJson.firstName } ${ responseJson.lastName }`;
                const shippingAddressStr = `${ responseJson.address1 },${ responseJson.address2 !== '' ? " " + responseJson.address2 : "" } ${ responseJson.city }, ${ responseJson.state } ${ responseJson.zip }`;
                this.setState({
                    shippingAddressName: shippingAddressName,
                    shippingAddressStr: shippingAddressStr,
                    shippingAddressCountry: responseJson.country
                }, this.calculateShipping);
           
            }).catch(function(err) {
                _this.fun_showShippingConten();
                console.log("Please input your credit card information and address on cart page before proceeding.");
            });
        }else{
            let shippingAddressStorageData = localStorage.getItem("shippingAddressStorageData");
            if(isJSON(shippingAddressStorageData)){
                try {
                    let  dataJson = JSON.parse(shippingAddressStorageData);
                    const shippingAddressName = `${ dataJson.firstName } ${ dataJson.lastName }`;
                    const shippingAddressStr = `${ dataJson.address1 },${ dataJson.address2 !== '' ? " " + dataJson.address2 : "" } ${ dataJson.city }, ${ dataJson.state } ${ dataJson.zip }`;
                    this.setState({
                        shippingAddressName: shippingAddressName,
                        shippingAddressStr: shippingAddressStr,
                        shippingAddressCountry: dataJson.country,
                        fnameShipping:dataJson.firstName,
                        lnameShipping:dataJson.lastName,
                        addressOneShipping:dataJson.address1,
                        addressTwoShipping:dataJson.address2,
                        cityShipping:dataJson.city,
                        zipShipping:dataJson.zip,
                        countryShipping:dataJson.country,
                        regionShipping:dataJson.state,

                    }, this.calculateShipping);
                } catch (error) {
                    _this.fun_showShippingConten();
                }
            }else{
                _this.fun_showShippingConten();
            }
           
        }

    }
    getQuickAddProducts = () => {
        const url = "/api/quick-add-products";
        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        }).then(response => {
            if (response.status === RESPONSE_STATUS.OK) {
                return response.json()
            } else {
                console.log("Please try again.");
            }
        }).then(responseJson => {
            const result = responseJson;
            this.setState({quickAddGoodsData: result })
        });
    }

     handleChangeAdddressInput = (e) => {
        e.persist();
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value });
    }

    handleShippingAddressFromBilling = () => {
        this.setState({ updateShippingAddressFromBilling: !this.state.updateShippingAddressFromBilling });
    }

    confirmZip = (zip, state, country) => {
        const stateCode = stateData[state];
        const url = `/api/taxjar/zip-state-match?zip=${zip}&state=${stateCode}&country=${country}`;
        if (country !== "Canada") {
            return fetch(url , {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    // 'x-auth-token': Api.auth_tokenManager()
                }
            })
            .then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    this.setState({ disableBillingButton: false });
                    throw new Error("Error confirming zip.")
                }
                
            }).then(responseJson => {
                return responseJson;
            }).catch(function(err) {
                alert("There was a problem confirming your address. Please try again.");
            });
        } else {
            let promise = new Promise ((resolve) => {
                resolve(true);
            })

            return promise.then(value => {
                return true;
            });
        }
        
    }

    replaceCardWithNewCard(token) {
        const url = '/api/charge-new-card';
        const userId = localStorage.getItem("user_id");
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            },
            body: JSON.stringify({
                "userId": userId,
                "stripeToken": token.id,
                "amount": '0.00',
                "idempotencyKey": this.idempotencyKey
            })
        })
        .then((response) =>
            {

                if ((response.headers.get('x-helloavaapp-error') && (response.status >= 400))) {
                    //Error handling
                    this.idempotencyKey = Api.getUUID();
                    this.setState({ errorMessageShow: true, errorMessage: response.headers.get('x-helloavaapp-error') });
                    throw new Error(response.headers.get('x-helloavaapp-error'));
                } else {
                    this.getCardDigits();
                    this.setState({ 
                        useExistingCard: true, 
                        disableBillingButton: false,
                        firstName: '',
                        lastName: '',
                        addressOne: '',
                        addressTwo: '',
                        city: '',
                        country: '',
                        region: '',
                        state: '',
                        updateShippingAddressFromBilling: false 
                    });
                }
            }
        )
        .catch((err) => {
            alert("There was a problem replacing your existing card: " + err);
        });
    }
    slidingProductsShow = (type, productsArrLength) => {
        if (productsArrLength != 0 && productsArrLength > 3) {
            let slidingNumber = this.state.productsAddElementBrakeBias;
            if (type === 'left') {
                slidingNumber = slidingNumber - (-182);
            } else if (type === 'right') {
                slidingNumber = slidingNumber + (-182);
            }
            slidingNumber = slidingNumber >= 0 ? 0 : slidingNumber;
            var arrowLeft = slidingNumber == 0 ? '-disabled' : '';
            var sumLength = (productsArrLength-3) * (-182);
            var arrowRight = slidingNumber <= sumLength ? '-disabled' : '';
            slidingNumber = slidingNumber <= sumLength ? sumLength : slidingNumber;

            this.setState({
                productsAddElementBrakeBias: slidingNumber,
                arrowLeftDisabled: arrowLeft,
                arrowRightDisabled: arrowRight,
            })
        } else {
            this.setState({
                arrowRightDisabled: '-disabled',
            })
        }
    }

	handleSubmit = (e) => {
        // e.persist();
		e.preventDefault();
        this.setState({ disablePurchaseButton: true });

        // console.log(this.state.useExistingCard);
        // console.log(this.state.card.cardBrand);
        // console.log(this.state.showShippingAddressSection);
        
        if(!this.state.useExistingCard && this.state.showShippingAddressSection ){
            alert("Please input your payment and shipping information to proceed with the checkout process.")
            this.setState({ disablePurchaseButton: false });
            return;
        }else if (!this.state.useExistingCard) {
            this.setState({ errorMessageShow: true, errorMessage: "Please fill out your credit card information." });
            this.setState({ disablePurchaseButton: false });
            alert("Please fill out your credit card information.")
            return;
        } else if (this.state.showShippingAddressSection) {
            this.setState({ errorMessageShow: true, errorMessage: "Please fill out your shipping information." });
            this.setState({ disablePurchaseButton: false });
            alert("Please fill out your shipping information.")
            return;
        }else if(this.state.card.cardBrand =='' && this.state.shippingAddressName ==''){
            alert("Please input your payment and shipping information to proceed with the checkout process.")
            this.setState({ disablePurchaseButton: false });
            return;
        }else if(this.state.card.cardBrand ==''){
            this.setState({ errorMessageShow: true, errorMessage: "Please fill out your credit card information." });
            this.setState({ disablePurchaseButton: false });
            return;
        }else if (this.state.shippingAddressName == '') {
            this.setState({ errorMessageShow: true, errorMessage: "Please fill out your shipping information." });
            this.setState({ disablePurchaseButton: false });
            alert("Please fill out your shipping information.")
            return;
        }  else {
            this.handleCheckout();
        }
    }

    handleReplaceNewCard = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (this.state.country === '' || this.state.region === '') {
            this.setState({ errorMessageShow: true, errorMessage: "Please provide your country and state." });
            return;
        }
        if (this.state.updateShippingAddressFromBilling) {
            this.handleSubmitShipping(e);
        }
        const name = this.state.firstName + " " + this.state.lastName;
        this.setState({ disableBillingButton: true, errorMessageShow: false });

        this.confirmZip(this.state.zip, this.state.region, this.state.country)
        .then(response => {
            if (!response) {
                this.setState({ disableBillingButton: false, errorMessageShow: true, errorMessage: "Please fill out a valid zip code for your state." });
                return;
            } else {
                this.fun_stripeCreateToken(name,this.state.addressOne,this.state.addressTwo,this.state.city,this.state.country,this.state.region,true);
                this.setState({
                    useExistingCard:true
                })
            }
        });
    }

    fun_stripeCreateToken(name,addressOne,addressTwo,city,country,state){
        this.props.stripe.createToken({
            name: name,
            address_line1: addressOne,
            address_line2: addressTwo,
            address_city: city,
            address_country: country,
            address_state: state
        }).then(({token}) => {
            if(localStorage.getItem("auth_token")){
                this.replaceCardWithNewCard(token);
            }else{
                try {
                    this.setState({
                        stripeToken: token.id,
                        card: {
                            cardDigits: token['card'].last4,
                            cardBrand: token['card'].brand
                        }
                    });
                } catch (error) {
                    this.getCardDigits();
                }
            }
        }).catch((err) => {
            this.setState({ disableBillingButton: false });
            this.setState({ errorMessageShow: true, errorMessage: "Please fill out the missing credit card information." });
        })
    }


    handleSubmitShipping = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ disableShippingButton: true });
        if (this.state.countryShipping === '' || this.state.regionShipping === '')
        {
            this.setState({ errorMessageShow: true, errorMessage: "Please provide your country and state.", disableShippingButton: false });
            return;
        }
        const userId = localStorage.getItem('user_id');
        const firstName = this.state.updateShippingAddressFromBilling ? this.state.firstName : this.state.fnameShipping;
        const lastName = this.state.updateShippingAddressFromBilling ? this.state.lastName : this.state.lnameShipping;
        const address1 = this.state.updateShippingAddressFromBilling ? this.state.addressOne : this.state.addressOneShipping;
        const address2 = this.state.updateShippingAddressFromBilling ? this.state.addressTwo : this.state.addressTwoShipping;
        const city = this.state.updateShippingAddressFromBilling ? this.state.city : this.state.cityShipping;
        const zip = this.state.updateShippingAddressFromBilling ? this.state.zip : this.state.zipShipping;

        
        const country = this.state.updateShippingAddressFromBilling ? this.state.country : this.state.countryShipping;
        const state = this.state.updateShippingAddressFromBilling ? this.state.region : this.state.regionShipping;
        

        this.confirmZip(zip, state, country)
        .then(response => {
            if (!response) {
                this.setState({ disableShippingButton: false, errorMessageShow: true, errorMessage: "Please fill out a valid zip code for your state." });
                    return;
            } else {
                if(localStorage.getItem("auth_token")){
                    fetch('/api/shipping-addresses', {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'x-auth-token': localStorage.getItem('auth_token')
                        },
                        body: JSON.stringify({
                            "userId": userId,
                            "firstName": firstName,
                            "lastName": lastName,
                            "address1": address1,
                            "address2": address2,
                            "country": country,
                            "zip": zip,
                            "city": city,
                            "state": state,
                            "stateCode": stateData[state],
                        })
                    }).then(response => {
                        if (!(response.status >= 200 && response.status < 300)) {
                            this.setState({ disableShippingButton: false });
                            throw new Error("Response status issue.");
                        } else {
                            this.getShippingAddress();
                            this.setState({ 
                                showShippingAddressSection: false, 
                                disableShippingButton: false,
                                fnameShipping: '',
                                lnameShipping: '',
                                addressOneShipping: '',
                                addressTwoShipping: '',
                                cityShipping: '',
                                regionShipping: '',
                                countryShipping: '',
                                zipShipping: '' 
                            });
                        }
                    }).catch(err => {
                        console.log('There was a problem saving your shipping address: ' + err);
                    });
                }else{
                    let dataStringJson = JSON.stringify({
                        "firstName": firstName,
                        "lastName": lastName,
                        "address1": address1,
                        "address2": address2,
                        "country": country,
                        "zip": zip,
                        "city": city,
                        "state": state,
                        "stateCode": stateData[state],
                      
                    })
                    localStorage.setItem("shippingAddressStorageData",dataStringJson);
                    this.getShippingAddress();
                    this.setState({
                        showShippingAddressSection:false,
                        isShowShippingConten: false
                    })
                }
                
            }
        });
        
    }

    //CODE MIGRATION
    sendDataForRevenueTracking(firstName, lastName, email, discountCode, discountAmount, orderTotal, totalPaid) {
        const url = 'https://hooks.zapier.com/hooks/catch/2569749/n9iu5d/';
        const discountAmountFormatted = this.state.discountType ==="percentage" ? discountAmount + "%" : "$" + discountAmount;
        const timestamp = renderTimestamp();
        if(firstName !='' && firstName != null){
            fetch(url, {
                method: 'POST',
                body: JSON.stringify({
                    "first_name": firstName,
                    "last_name": lastName,
                    "email": email,
                    "discount_code": discountCode,
                    "discount_amount": discountAmountFormatted,
                    "order_total": orderTotal,
                    "total_paid_customer": totalPaid,
                    "timestamp": timestamp
                })
            })
            .catch(function(err) {
                alert("There was a problem sending your info. Please try again.");
            });
        }else {
            alert("user name is empty. Please login again");
        }
    }

    sendAmountPaidForRecord(email, totalAmount, amountPaid) {
        return new Promise((resolve, reject) => {
          const url = 'https://hooks.zapier.com/hooks/catch/2569749/7o5goa/';
          fetch(url, {
              method: 'POST',
              body: JSON.stringify({
                  "email": email,
                  "totalAmount": totalAmount,
                  "amountPaid": amountPaid
              })
          }).then(response => {
              res => res.json()
          }).then(data => resolve(data))
          .catch(err => reject(err))
        })
    }

    // 清空购物车
    fun_clearCart() {
      return new Promise((resolve, reject) => {
        const userId = localStorage.getItem("user_id");
        fetch('/api/clear-cart?user-id=' + userId, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-auth-token': Api.auth_tokenManager()
          }
        }).then(response => {
          res => res.json()
        }).then(data => resolve(data))
        .catch(err => reject(err))
      })
     
    }

    handleCheckout = () => {
        // this.props.toggleLoading(true);
        this.setState({
          isCheckoutButton:true
        });
        var orderProductsData = Object.assign([], this.state.productsArr);
        var gtmORderInfoTrack = [];  /// 谷歌追踪订单商品信息

        // 判断产品有效性，和库存不能为零，和购买数量不能大于库存数量
        let isEntitle = this.state.isEntitle;
        let productsVariantsCart = this.state.productsArr.map(product => {
            if(product.available && product.inventory > 0){
                try {
                    gtmORderInfoTrack.push({
                        'name': product.name,
                        'id': product.id,
                        'price': product.price,
                        'brand':   product.vendor,
                        'category': product.type,
                        'quantity': product.inventory <= product.quantity ? product.inventory : product.quantity,
                        'coupon':  isEntitle.indexOf(product.id) != -1 ? this.state.promoCodeSaved : '',
                    });
                } catch (error) {}
                
                // 'coupon': '' // 优惠code 使用的优惠代码是否适用这件商品
                return product.variantId + ":"+   ( product.inventory <= product.quantity ? product.inventory : product.quantity) ;
            }
        });
        var productsVariants = productsVariantsCart.filter(function (s) {
            return s && s.trim();
        });

        var orderProductsData_1 = [];
        orderProductsData.map(product => {
            if(product.available && product.inventory > 0 ){
                orderProductsData_1.push(product)
            }
        });

         if(productsVariants.length < 1 ){
             alert('Out of stock');
             this.setState({isCheckoutButton:false})
             return false;
         }
        const amountPaidGateFee = this.props.amountPaidGateFee;
        const userHasPurchased = localStorage.getItem("recohaspurchased");
        const userId = localStorage.getItem("user_id");
            
        let amountFirstPurchase = parseFloat(this.state.price) - amountPaidGateFee;
        let price = this.props.eligibleForDiscount ? amountFirstPurchase : parseFloat(this.state.price);
        let amountAfterDiscount = 0; 

        if (this.state.discountType !== "percentage") {
            amountAfterDiscount = parseFloat(price) - parseFloat(this.state.amountAvailableForDiscount) > 0 ? parseFloat(price) - parseFloat(this.state.amountAvailableForDiscount) : 0;
        } else {
            amountAfterDiscount = price * ((100 - parseFloat(this.state.amountAvailableForDiscount)) / 100) >= 0 ? price * ((100 - parseFloat(this.state.amountAvailableForDiscount)) / 100) : 0;
        }
        
        let finalPricePreShippingTax = this.state.amountAvailableForDiscount > 0 ? amountAfterDiscount : price;
        let finalPrice = finalPricePreShippingTax + this.state.shippingRate + this.state.tax;
        const url = '/api/charge-card';
        let goodsNumber = this.props.cartGoodsCount();

        let bodyData = "";
        if( localStorage.getItem("auth_token") ){
            bodyData = JSON.stringify({
                "userId": userId,
                "amount": finalPrice.toFixed(2),
                "idempotencyKey": this.idempotencyKey,
                "productVariants": productsVariants.toString(),
                "shipping": parseFloat(this.state.shippingRate).toFixed(2),
                "tax": parseFloat(this.state.tax).toFixed(2),
                "promoCode": this.calculatePromo() != '-$0' ? this.calculatePromo() : 0,
                "newSubtotal":  this.state.discountPrice > 0 ? "$" + parseFloat(this.state.discountPrice).toFixed(2) : 0,
                "amountPaidGateFee": this.props.amountPaidGateFee > 0 ? "-$" +parseFloat(this.props.amountPaidGateFee).toFixed(2) : 0,
                "discountCode": this.state.promoCodeSaved,
            })
        }else{
            bodyData = JSON.stringify({
                "amount": finalPrice.toFixed(2),
                "idempotencyKey": this.idempotencyKey,
                "productVariants": productsVariants.toString(),
                "shipping": parseFloat(this.state.shippingRate).toFixed(2),
                "tax": parseFloat(this.state.tax).toFixed(2),
                "promoCode": this.calculatePromo() != '-$0' ? this.calculatePromo() : 0,
                "newSubtotal":  this.state.discountPrice > 0 ? "$" + parseFloat(this.state.discountPrice).toFixed(2) : 0,
                "amountPaidGateFee": this.props.amountPaidGateFee > 0 ? "-$" +parseFloat(this.props.amountPaidGateFee).toFixed(2) : 0,
                "discountCode": this.state.promoCodeSaved,
                "stripeToken": this.state.stripeToken,
                "firstName":this.state.contactInformation_firstName,
                "lastName":this.state.contactInformation_lastName,
                "email":this.state.contactInformation_email,

                "shipFirstName": this.state.shipFirstName,
                "shipLastName": this.state.lnameShipping,
                "shipAddress1": this.state.addressOneShipping,
                "shipAddress2": this.state.addressTwoShipping,
                "shipZip": this.state.zipShipping,
                "shipCity": this.state.cityShipping,
                "shipCountry": this.state.countryShipping,

                "shipProvince": this.state.regionShipping,
            })
        }


        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                // 'x-auth-token': Api.auth_tokenManager()
            },
            body: bodyData,
        })
        // .then((response) => response.json())
        .then(response =>{
            if(response.status >= 500){
                alert('Internal Server Error');
            }else{
                return response.json()
            }
        })
        .then(response => {
            if(response.errorCode || response.errorCode == 422 || response.errorCode == 402 || response.fieldErrors){
                alert(response.errorMessage);
                this.setState({isCheckoutButton:false});
            }else{

                if (this.state.promoCodeSaved.length > 0 && this.state.discountOncePerCustomer && localStorage.getItem("auth_token") ) {
                    this.redeemGiftCardInFull();
                }
                
                if(this.state.promoCode){
                    not_logged_DiscountCodeLog_decide(this.state.promoCode,true);
                }
                
                let user_global_firstname = localStorage.getItem("user_global_firstname");
                let user_global_lastname = localStorage.getItem("user_global_lastname");
                let user_global_email = localStorage.getItem("user_global_email");
                if(!localStorage.getItem("auth_token")){
                    user_global_firstname = this.state.fnameShipping;
                    user_global_lastname = this.state.lnameShipping;
                    user_global_email = this.state.contactInformation_email;
                }

                if (this.state.promoCodeSaved.length > 0) this.sendDataForRevenueTracking(user_global_firstname, user_global_lastname, user_global_email, this.state.promoCodeSaved, this.state.amountAvailableForDiscount, this.state.price, finalPrice);

                if (localStorage.getItem("first_time_purchase")) {
                    localStorage.setItem("has_purchased", true);
                    localStorage.removeItem("first_time_purchase");
                }

                this.sendAmountPaidForRecord(user_global_email, this.state.price, finalPricePreShippingTax).then(reponse =>{
                    if(localStorage.getItem("auth_token")){
                        this.fun_clearCart().then(reponese =>{
                            this.setState({ isCheckoutButton:false })
                            this.props.fun_deleteAllCartGoodsData();
                            //shopifyOrderNumber 是 shopify 返回的订单号 。shopifyOrderId 在数据库中是 sourceOrderId
                            this.props.showThankYou(response['shopifyOrderNumber'],finalPrice.toFixed(2),response['shopifyOrderId'],orderProductsData_1, goodsNumber, parseFloat(this.state.tax).toFixed(2), parseFloat(this.state.shippingRate).toFixed(2), this.state.promoCodeSaved, gtmORderInfoTrack );
                        })
                    }else{
                        this.setState({ isCheckoutButton:false })
                        this.props.fun_deleteAllCartGoodsData();
                        //shopifyOrderNumber 是 shopify 返回的订单号 。shopifyOrderId 在数据库中是 sourceOrderId
                        this.props.showThankYou(response['shopifyOrderNumber'],finalPrice.toFixed(2),response['shopifyOrderId'],orderProductsData_1, goodsNumber, parseFloat(this.state.tax).toFixed(2), parseFloat(this.state.shippingRate).toFixed(2), this.state.promoCodeSaved, gtmORderInfoTrack);
                    }
                })
            }
        })
        .catch((err) => {
            console.log(err)
            // this.props.toggleLoading(false);
            this.setState({ isCheckoutButton:false })
            this.idempotencyKey = Api.getUUID();
            this.setState({ disablePurchaseButton: false });
            alert("We do not have your credit card on file. Please input your credit card information by selecting “Replace with new card” in the payment method section. ");
        });
    }

    //END CODE MIGRATION

    fun_showPaymentConten = ()=>{
        this.setState({
            isShowPaymentConten: !this.state.isShowPaymentConten
        })
    }

    fun_showShippingConten = ()=>{
        this.setState({
            isShowShippingConten: !this.state.isShowShippingConten
        })
    }



    //Checkbox for Showing Shipping Address Section
    handleCheckChangeShippingAddress() {
        this.setState({ showShippingAddressSection: !this.state.showShippingAddressSection });
    }


   checkIfPromoCodeExists(e) {
        e.preventDefault();
        
        if (this.state.promoCode.length === 0) {
            alert('No promo code entered. Please enter a promo code.');
            return;
        }
        
        if(localStorage.getItem("auth_token")){

            //ONLY APPLY AVAFIRST15 TO FIRST PURCHASE
            if (this.state.promoCode.toUpperCase() === process.env.REACT_APP_PROMO_CODE && !this.props.hasNotPurchased) {
                this.setState({ showPromoSuccessMessage: true, promoCodeError: `Promo code ${ process.env.REACT_APP_PROMO_CODE } can only be applied to your first purchase.` });
                return;
            }
            this.setState({ isApplyButton:true });
            this.checkIfPreviouslyUsedDiscountCode(this.state.promoCode).then(response => {
                if (response) {
                    return this.setState({isApplyButton:false, showPromoSuccessMessage: true, promoCodeError: "Promo code only has already been used." });
                } else {
                    this.fun_shopifyPromoPriceRule();
                }
            })
            
        }else{
            if(not_logged_DiscountCodeLog_decide(this.state.promoCode)){
                return this.setState({ showPromoSuccessMessage: true, promoCodeError: "Promo code only has already been used." });
            }else{
                this.fun_shopifyPromoPriceRule();
            }
        }
    }

    fun_shopifyPromoPriceRule () {
        this.setState({ isApplyButton:true });
        const url = '/api/shopify/promo-price-rule?code=' + this.state.promoCode;
        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
        .then(response => {
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            } else if (response.status >= 400 && response.status < 500) {
                this.setState({ showPromoSuccessMessage: true, promoCodeError: "Promo code does not exist." });
                this.setState({ isApplyButton:false });
            } else {
                this.setState({ showPromoSuccessMessage: true, promoCodeError: "There was a problem checking the eligibility of your promo code." });
                this.setState({ isApplyButton:false });
            }
        })
        .then((resJson) => {
            // console.log(typeof Math.abs(resJson.price_rule.value));
            this.setState({
                discountCodeData: resJson,
                isEntitlePrice:0,
            });

            if (Math.abs(resJson.price_rule.value) > 0) {
                let discountCodes = this.state.discountCodes;
                let expirationDate = resJson.price_rule.ends_at ? resJson.price_rule.ends_at : null;
                

                if (resJson.price_rule.prerequisite_subtotal_range && (resJson.price_rule.prerequisite_subtotal_range.greater_than_or_equal_to >= parseFloat(this.state.price))) {
                    this.setState({ showPromoSuccessMessage: true }, () => {
                        this.setState({isApplyButton:false, promoCodeError: "Promo code " + this.state.promoCodeSaved + " only applies to purchases of $" +  parseFloat(resJson.price_rule.prerequisite_subtotal_range.greater_than_or_equal_to).toFixed(2) + " or more." });
                    });
                    return;
                }else {
                    this.setState({ promoCodeError:''});
                }

                // 判断 指定的产品才能使用折扣码
                try {
                    
                    let entitledProductIds =  resJson.price_rule.entitled_product_ids;
                    let productsArr = this.state.productsArr;
                    let isEntitle = [];
                    let isEntitlePrice = 0;

                    if(entitledProductIds.length > 0 ){
                        entitledProductIds.forEach(entID => {
                            productsArr.forEach(products =>{
                                if(entID == products.id){
                                    isEntitle.push(entID);
                                    if(products.available){
                                        isEntitlePrice += Math.abs(products.price) * (products.quantity ? products.quantity : 1)
                                    }
                                    
                                }
                            })
                        });

                        if(isEntitle.length < 1){
                            this.setState({ showPromoSuccessMessage: true }, () => {
                                this.setState({ 
                                    promoCodeError: "This promo code is only valid for specific products",
                                    isEntitlePrice:0,
                                    isApplyButton:false,
                                    isEntitle: isEntitle,
                                    // promoCodeSaved: "",
                                    // showPromoSuccessMessage: false,
                                    // discountMinimumAmount: "",
                                    // discountOncePerCustomer: "",
                                 });
                            });
                            return;
                        }else {
                            this.setState({
                                isEntitlePrice : isEntitlePrice,
                                isEntitle: isEntitle,
                                promoCodeError:'',
                            });
                        }

                        if (resJson.price_rule.prerequisite_subtotal_range && (resJson.price_rule.prerequisite_subtotal_range.greater_than_or_equal_to >= parseFloat(isEntitlePrice))) {
                            this.setState({ showPromoSuccessMessage: true }, () => {
                                this.setState({ promoCodeError: "Promo code " + this.state.promoCodeSaved + " only applies to purchases of $" +  parseFloat(resJson.price_rule.prerequisite_subtotal_range.greater_than_or_equal_to).toFixed(2) + " or more." });
                            });
                            return;
                        }else {
                            this.setState({ promoCodeError:''});
                        }

                    }
                } catch (error) {
                    console.log(error);
                    this.setState({ isApplyButton:false });
                }
                
                //检查促销代码是否已过期 
                if (this.checkIfPromoCodeHasExpired(expirationDate)) {
                        this.setState({ showPromoSuccessMessage: true, promoCodeError: '' }, () => {
                            this.setState({isApplyButton:false, promoCodeError: "Promo code " + this.state.promoCode + " has expired." });
                        });
                        return;
                }else {
                    this.setState({ promoCodeError:''});
                }


                this.setState({ 
                    amountAvailableForDiscount: Math.abs(resJson.price_rule.value),
                    discountType: resJson.price_rule.value_type,
                    // discountExpirationDate: resJson.price_rule.ends_at ? resJson.price_rule.ends_at : "",
                    discountMinimumAmount: resJson.price_rule.prequisite_subtotal_range,
                    discountOncePerCustomer: resJson.price_rule.once_per_customer,
                    showPromoSuccessMessage: true,
                    promoCodeSaved: this.state.promoCode,
                    discountCodes: discountCodes,
                    targetType: resJson.price_rule.target_type
                }, () => {
                    this.setState({ showPromoSuccessMessage: true,isApplyButton:false });
                    this.calculateShipping()
                });
                

            } else {
                this.setState({ showPromoSuccessMessage: true, promoCodeSaved: this.state.promoCode,isApplyButton:false }, () => {
                    this.setState({ promoCodeError: "Promo code " + this.state.promoCodeSaved + " has already been redeemed." });
                });
                                
            }  
        }).catch((err) => {
            console.log(err);
        });
    }

    checkIfPreviouslyUsedDiscountCode = (code) => {
        const userId = localStorage.getItem("user_id");
        const url = `/api/used-discount-codes/exist?user-id=${ userId }&code=${ code }`;

        
        return fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': localStorage.getItem('auth_token')
            }
        })
        .then(response => response.json())
        .then(resJson => {
            return resJson;
        })
        .catch(err => console.log("There was a problem checking your discount code."));
    }

    checkIfPromoCodeHasExpired = (date) => {
        if (date === null) {
            return false;
        }
        const expireTime = new Date(date);
        const currentTime = new Date();

        return expireTime.getTime() - currentTime.getTime() < 0;
    }

    /*** END PROMO CODE FLOW ***/

    calculatePromo() {
        let price = ((this.props.eligibleForDiscount) && this.props.amountPaidGateFee > 0) ? parseFloat(this.state.price) - this.props.amountPaidGateFee : parseFloat(this.state.price);
        let isEntitlePrice = 0;

        if(this.state.discountType === "percentage"){
            let discountCodeData = this.state.discountCodeData;
            let entitledProductIds = discountCodeData.price_rule.entitled_product_ids ? discountCodeData.price_rule.entitled_product_ids: [] ;
            let productsArr = this.state.productsArr;

            if(entitledProductIds){
            entitledProductIds.forEach(entID => {
                productsArr.forEach(products =>{
                    if(entID == products.id){
                        if(products.available){
                            isEntitlePrice += Math.abs(products.price) * (products.quantity ? products.quantity : 1)
                        }
                        
                    }
                })
            });
            }

            var valueString = "-" + this.state.amountAvailableForDiscount + "% ($" +  parseFloat((price * (this.state.amountAvailableForDiscount / 100))).toFixed(2) + ")";
            if(entitledProductIds.length > 0 ){
                if(isEntitlePrice > 0 ){
                    valueString = "-" + this.state.amountAvailableForDiscount + "% ($" +  parseFloat((isEntitlePrice * (this.state.amountAvailableForDiscount / 100))).toFixed(2) + ")";
                }else{
                    valueString = '';
                }
            }

            if(this.state.targetType == "shipping_line"){
            let shipping = 0;
            if (this.state.shippingAddressCountry === "Canada") shipping = 13.99;
            else if(this.state.shippingAddressCountry === "United Kingdom") shipping = 17.99;
            else if (price <= 50) shipping = 6.99;
            else shipping = 0;
            if( this.state.targetType == 'shipping_line' && shipping > 0 ){
                    shipping * ( parseFloat(this.state.amountAvailableForDiscount) / 100);
            }
            valueString = "-" + this.state.amountAvailableForDiscount + "% ($" +  parseFloat(  shipping  ).toFixed(2) + ")";
            }

            return valueString;
        }else{
            return "-$" + this.state.amountAvailableForDiscount;
        }

        // return this.state.discountType === "percentage" ? "-" + this.state.amountAvailableForDiscount + "% ($" +  parseFloat((price * (this.state.amountAvailableForDiscount / 100))).toFixed(2) + ")" : "-$" + this.state.amountAvailableForDiscount
    }

    calculateShipping() {
        let shipping = 0;
        let discountType = this.state.discountType;

        let price = parseFloat(this.state.price);
        // if ((this.props.userPaidGateFee && this.props.hasNeverPurchased) && this.props.amountPaidGateFee > 0) price -= this.props.amountPaidGateFee;
        if ((this.props.eligibleForDiscount) && this.props.amountPaidGateFee > 0) price -= this.props.amountPaidGateFee;


        if (this.state.amountAvailableForDiscount > 0 && this.state.targetType != 'shipping_line' ) {
            if (discountType !== "percentage") {
                price = price - parseFloat(this.state.amountAvailableForDiscount) >= 0 ? price - this.state.amountAvailableForDiscount : 0;
            } else {
                let isEntitlePrice = this.state.isEntitlePrice
                if(isEntitlePrice > 0){

                    price = ( price - isEntitlePrice * (parseFloat(this.state.amountAvailableForDiscount) / 100) ) >= 0 ? price - isEntitlePrice * ( parseFloat(this.state.amountAvailableForDiscount) / 100) : 0;
                
                }else{
                    price = price * ((100 - parseFloat(this.state.amountAvailableForDiscount)) / 100) >= 0 ? price * ((100 - parseFloat(this.state.amountAvailableForDiscount)) / 100) : 0;
                }
            }
        }
      
        if(parseFloat(this.state.price) != price ){
            this.setState({ discountPrice: price})
        }else {
            this.setState({ discountPrice: 0})
        }
        
        let originalShipping = 0;
        if (this.state.shippingAddressCountry === "Canada") shipping = 13.99;
        else if(this.state.shippingAddressCountry === "United Kingdom") shipping = 17.99;
        else if (price <= 50) shipping = 6.99;
        else shipping = 0;
        originalShipping = shipping;
        
        // 折扣码是免运费的处理
        if( this.state.targetType == 'shipping_line' && shipping > 0 ){
            if(discountType == "percentage"){
                if(this.state.amountAvailableForDiscount == 100){
                    shipping = 0
                }else{
                    shipping = shipping * ( parseFloat(this.state.amountAvailableForDiscount) / 100);
                }
            }else{
                shipping = shipping - ( parseFloat(this.state.amountAvailableForDiscount) / 100);
            }
            if(shipping < 0) shipping = 0;
        }
        this.setState({ shippingRate: shipping,originalShipping:originalShipping  }, this.calculateTax);
    }

    calculateTax() {
        const userId = localStorage.getItem("user_id");
        let price = parseFloat(this.state.price);
        // if ((this.props.userPaidGateFee && this.props.hasNeverPurchased) && this.props.amountPaidGateFee > 0) price -= this.props.amountPaidGateFee;
        if ((this.props.eligibleForDiscount) && this.props.amountPaidGateFee > 0) price -= this.props.amountPaidGateFee;
        if (this.state.amountAvailableForDiscount > 0 && this.state.targetType != 'shipping_line' ) {
            if (this.state.discountType !== "percentage") {
                price = price - parseFloat(this.state.amountAvailableForDiscount) >= 0 ? price - this.state.amountAvailableForDiscount : 0;
            } else {
                price = price * ((100 - parseFloat(this.state.amountAvailableForDiscount)) / 100) >= 0 ? price * ((100 - parseFloat(this.state.amountAvailableForDiscount)) / 100) : 0;
            }
        }
        
        let amountForTax = price;
        let shippingRate = this.state.shippingRate;
        let originalShipping = this.state.originalShipping;
        if(originalShipping != 0){
            shippingRate = originalShipping;
        }

        let url = `/api/taxjar/sales-tax?user-id=${userId}&amount=${amountForTax}&shipping=${shippingRate}`;
        if(!localStorage.getItem("auth_token")){
            url = `/api/taxjar/sales-tax?amount=${amountForTax}&shipping=${shippingRate}&country=${this.state.countryShipping}&state=${this.state.regionShipping}&zip=${this.state.zipShipping}`;
        }


        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then((response) => {
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            } else {
                console.log("No card");
            }
            
        }).then(responseJson => {
            this.setState({
                tax: responseJson
            });
        }).catch(function(err) {
            console.log("执行这个  /api/taxjar/sales-tax?user-id=  出错")
            // alert("There is a problem to get the account info. Please try again.");
        });
    }

    calculateFinalPrice() {
        let price = parseFloat(this.state.price);
        let amountDiscount = 0;
        if ((this.props.eligibleForDiscount) && this.props.amountPaidGateFee > 0) price -= this.props.amountPaidGateFee;
        if (this.state.amountAvailableForDiscount > 0 && this.state.targetType != 'shipping_line') {

            if (this.state.discountType !== "percentage") {
                price = price - parseFloat(this.state.amountAvailableForDiscount) >= 0 ? price - this.state.amountAvailableForDiscount : 0;
            } else {
                let isEntitlePrice = this.state.isEntitlePrice;
                if(isEntitlePrice > 0){
                    price = ( price - isEntitlePrice * (parseFloat(this.state.amountAvailableForDiscount) / 100) ) >= 0 ? price - isEntitlePrice * ( parseFloat(this.state.amountAvailableForDiscount) / 100) : 0;
                }else{
                    price = price * ((100 - parseFloat(this.state.amountAvailableForDiscount)) / 100) >= 0 ? price * ((100 - parseFloat(this.state.amountAvailableForDiscount)) / 100) : 0;
                }
            }
            
        }
        let finalPrice = price - amountDiscount + this.state.shippingRate + this.state.tax;
        return finalPrice.toFixed(2);
    }

    recalculate = () => {
        this.calculatePromo();
        // this.getShippingAddress();
        this.calculateFinalPrice();
    }
    // 购物车中计算价格。其中运费啊。折扣啊。税费啊。
    YouMightAlsoLike = () => {
        this.setState({ amountAvailableForDiscount: 0,
            discountType: "",
            discountMinimumAmount: "",
            discountOncePerCustomer: "",
            promoCodeError:"",
            showPromoSuccessMessage: false,
            promoCodeSaved: "",
            isEntitlePrice:0,
            discountCodeData:'',
         }, () => {
                // this.calculatePromo();
                // this.getShippingAddress();
                // this.calculateFinalPrice();
            });
    }

    fun_handleDeleteProduct_emptyData = () =>{
        this.setState({ amountAvailableForDiscount: 0,
            discountType: "",
            discountMinimumAmount: "",
            discountOncePerCustomer: "",
            showPromoSuccessMessage: false,
            promoCodeError:"",
            promoCodeSaved: "" });
    }

    fun_changeGoodsQuantity = (productObj,actionType) =>{
        if(productObj){
            this.props.addOrDeleteCartGoodsData(productObj,actionType)
        }
        
    }

    getGenderId() {
        const userId = localStorage.getItem("user_id");
        fetch('/api/user-account-info/' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then((response) => response.json()).then(responseJson => {
                if(!! responseJson){
                    localStorage.setItem("user_account_info", JSON.stringify(responseJson));
                }
        }).catch(function(err) {
            console.log("There is a problem to get the account info. Please try again.");
        });
    }

    /*** STEP 2 ***/
    //Render section
    renderPaymentSection() {
        return(
            <div className="checkout-block-content" >
            
                <div className="checkout-block-content-section bottom-checkout-section">
                    <form className="checkout-form" onSubmit={ this.handleReplaceNewCard }>
                        
                            <div className="block-content checkout" style={{ paddingBottom: '0em'}}>
                                <div className="credit-card-logos">
                                    <div className="credit-card-logo"><img alt="Visa" src="/images/gate/visa.png" /></div>
                                    <div className="credit-card-logo"><img alt="Mastercard" src="/images/gate/mastercard.png" /></div>
                                    <div className="credit-card-logo"><img alt="Discover" src="/images/gate/discover.png" /></div>
                                    <div className="credit-card-logo"><img alt="American Express" src="/images/gate/amex.png" /></div>
                                    <div className="credit-card-logo"><img alt="JCB" src="/images/gate/jcb.png" /></div>
                                    <div className="credit-card-logo"><img alt="Diner's" src="/images/gate/diners.png" /></div>
                                </div>

                                <label>
                                    <CardElement
                                        style={{
                                            base: {
                                                color: '#272d67',
                                                fontSize: '15px',
                                                fontFamily: 'Montserrat, Helvetica, Arial, sans-serif'
                                            }
                                        }}
                                        hidePostalCode={ true }
                                    />
                                </label>

                                <div className="credit-card-header">
                                    <h3>Billing Info</h3>
                                </div>
                                
                                <div className="fname-lname-row">
                                    <label className="text-label">
                                        {/*<div className="card-label addressOne">First Name</div>*/}
                                        <div className={ this.state.firstName !== '' ? "input-title" : "input-title hidden" } >First Name</div>
                                        <input onChange={ this.handleChangeAdddressInput }  name="firstName" value={ this.state.firstName } type="text" placeholder="First Name" required={ !this.state.useExistingCard }/>
                                    </label>

                                    <label className="text-label">
                                        <div className={ this.state.lastName !== '' ? "input-title" : "input-title hidden" } >Last Name</div>
                                        <input onChange={ this.handleChangeAdddressInput }  name="lastName" value={ this.state.lastName } type="text" placeholder="Last Name" required={ !this.state.useExistingCard }/>
                                    </label>
                                </div>

                                <div className="address-section billing-info" style={{marginBottom: '0.5em'}}>
                                    <label className="text-label">
                                        <div className={ this.state.addressOne !== '' ? "input-title" : "input-title hidden" } >Address</div>
                                        <input className="input-type" onChange={ this.handleChangeAdddressInput }  name="addressOne" value={ this.state.addressOne } type="text" placeholder="Address" required={ !this.state.useExistingCard } />
                                    </label>

                                    <label className="text-label">
                                        <div className={ this.state.addressTwo !== '' ? "input-title" : "input-title hidden" } >Apt/Floor/Suite</div>
                                        <input onChange={ this.handleChangeAdddressInput }  name="addressTwo" value={ this.state.addressTwo }type="text" placeholder="Apt/Floor/Suite" />
                                    </label>

                                    

                                    <div className="country-state-zip shipping-address">
                                        <label className="text-label">
                                        <div className={ this.state.city !== '' ? "input-title" : "input-title hidden" } >City</div>
                                        <input onChange={ this.handleChangeAdddressInput }  name="city" value={ this.state.city } type="text" placeholder="City" required={ !this.state.useExistingCard } />
                                    </label>

                                        <label className="text-label">
                                            <div className={ this.state.zip !== '' ? "input-title" : "input-title hidden" } >Zip Code</div>
                                            <input onChange={ this.handleChangeAdddressInput }  name="zip" value={ this.state.zip } type="text" placeholder="Zip Code" maxLength="7" required={ !this.state.useExistingCard }/>
                                        </label>
                                    </div>

                                    <div className="country-state-zip">
                                        <label>
                                            <CountryDropdown
                                                value={this.state.country}
                                                defaultOptionLabel="Select Country"
                                                onChange={(val) => this.selectCountry(val)}
                                                whitelist={["US", "CA", "GB"]}
                                            />
                                        </label>
                                        <label>
                                            <RegionDropdown
                                                country={this.state.country}
                                                value={this.state.region}
                                                defaultOptionLabel={this.state.country === "United States" ? "State" : this.state.country === "Canada" ? "Province" : "State/Province"}
                                                onChange={(val) => this.selectRegion(val)}
                                            />
                                        </label>
                                        
                                    </div> 
                                    <div className="update-shipping-address" onClick={ this.handleShippingAddressFromBilling }>
                                        <input name="showShippingAddressSection" type="checkbox" checked={ this.state.updateShippingAddressFromBilling } onChange={ this.handleShippingAddressFromBilling } />
                                        <span className="checkmark-custom"></span>
                                        <div className="update-shipping-address-text">
                                            Update my shipping address using the same address
                                        </div>
                                    </div>
                                </div>
                                <button /*onClick={ this.handleSubmit }*/disabled={ this.state.disableBillingButton} >
                                    Save
                                </button>
                            </div>
                        
                    </form>
                    
                </div>
            </div>
        );
    }

    renderShippingSection() {
        return(
            <div className="checkout-block-content" >
                <div className="checkout-block-content-section bottom-checkout-section">
                    <form className="checkout-form" onSubmit={ this.handleSubmitShipping }>
                            <div className="block-content checkout">
                                <div className={ this.state.showShippingAddressSection ? "address-section shipping-info expanded" : "address-section shipping-info" }>
                                    <div className="fname-lname-row">
                                        <label className="text-label">
                                            <div className={ this.state.fnameShipping !== '' ? "input-title" : "input-title hidden" } >First Name</div>
                                            <input onChange={ this.handleChangeAdddressInput }  name="fnameShipping" value={ this.state.fnameShipping } type="text" placeholder="First Name" required={ this.state.showShippingAddressSection }/>
                                        </label>

                                        <label className="text-label">
                                            <div className={ this.state.lnameShipping !== '' ? "input-title" : "input-title hidden" } >Last Name</div>
                                            <input onChange={ this.handleChangeAdddressInput }  name="lnameShipping" value={ this.state.lnameShipping } type="text" placeholder="Last Name" required={ this.state.showShippingAddressSection }/>
                                        </label>
                                    </div>

                                    <label className="text-label">
                                        <div className={ this.state.addressOneShipping !== '' ? "input-title" : "input-title hidden" } >Address</div>
                                        <input onChange={ this.handleChangeAdddressInput }  name="addressOneShipping" value={ this.state.addressOneShipping } type="text" placeholder="Address" required={ this.state.showShippingAddressSection }/>
                                    </label>

                                    <label className="text-label">
                                        <div className={ this.state.addressTwoShipping !== '' ? "input-title" : "input-title hidden" } >Apt/Floor/Suite</div>
                                        <input onChange={ this.handleChangeAdddressInput }  name="addressTwoShipping" value={ this.state.addressTwoShipping }type="text" placeholder="Apt/Floor/Suite" />
                                    </label>

                                    <div className="country-state-zip shipping-address">
                                        <label className="text-label">
                                            <div className={ this.state.cityShipping !== '' ? "input-title" : "input-title hidden" } >City</div>
                                            <input onChange={ this.handleChangeAdddressInput }  name="cityShipping" value={ this.state.cityShipping } type="text" placeholder="City" required={ this.state.showShippingAddressSection }/>
                                        </label>

                                        <label className="text-label">
                                            <div className={ this.state.zipShipping !== '' ? "input-title" : "input-title hidden" } >Zip Code</div>
                                            <input onChange={ this.handleChangeAdddressInput }  name="zipShipping" value={ this.state.zipShipping } type="text" placeholder="Zip Code" maxLength="7" required={ this.state.showShippingAddressSection }/>
                                        </label>
                                    </div>
                                    <div className="country-state-zip shipping-address">
                                        <label>
                                            <CountryDropdown
                                                value={ this.state.countryShipping }
                                                defaultOptionLabel="Select Country"
                                                onChange={(val) => this.selectCountryShipping(val)}
                                                whitelist={["US", "CA", "GB"]}
                                            />
                                        </label>
                                        <label>
                                            <RegionDropdown
                                                country={ this.state.countryShipping }
                                                value={ this.state.regionShipping }
                                                defaultOptionLabel={this.state.countryShipping === "United States" ?  "State" : this.state.countryShipping === "Canada" ? "Province" : "State/Province"}
                                                onChange={(val) => this.selectRegionShipping(val)}
                                            />
                                        </label>
                                        
                                    </div>
                                </div>
                                <button /*onClick={ this.handleSubmit }*/disabled={ this.state.disableShippingButton } >
                                    Save
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
        );
    }
    renderQuickAdd() {
        const productsArr = this.state.quickAddGoodsData;
        let productsArrLength = 0
        if (productsArr) {
            productsArrLength = productsArr.length;
        } else {
            return (<div></div>)
        }
        const cartBlocks = productsArr.map((product,index) => {
            return(
                <RecommendationsProduct
                    productCart={ this.props.productCart }
                    product={product} index={ index } key={`quickAdd-product--${index}`}
                    isFirstTime={ false }
                    saveCartForLater={ this.props.saveCartForLater }
                    syncProductsForOrderPageFromQuickAdd={ this.props.syncProducts }
                    productsArrFromOrderPage={ this.state.productsArr }
                    recalculate = {this.YouMightAlsoLike}
                    />
            );
        });

        return(
            <div className="products-quick">
                {/* <img onClick={this.slidingProductsShow.bind(this, 'left', productsArrLength)} className="icon-left-arry" src={"/images/recommendations/arrow-left"+this.state.arrowLeftDisabled+".svg"}></img> */}
                {/* <div className="products-add" style={{transform:`translate3d(${this.state.productsAddElementBrakeBias}px, 0px, 0px)`}}> */}
                <div className="products-add">
                    { cartBlocks }
                </div>
                {/* <img onClick={this.slidingProductsShow.bind(this, 'right', productsArrLength)} className="icon-right-arry" src={"/images/recommendations/arrow-right"+this.state.arrowRightDisabled+".svg"}></img> */}
            </div>
        );

    }

    renderCart() {
        const productsArr = this.state.productsArr;
     
        const cartBlocks = productsArr.map((product,index) => {
            let productName = product.name;
            // if(product.name){
            //     productName = product.name.includes(product.vendor) ? product.name : product.vendor + " " + product.name;
            // }
            const price = "$" + product.price;
            let available = product.available;
            return(
                <RecommendationsCartItem key={index} amountAvailableForDiscount= {this.state.amountAvailableForDiscount} discountCodeData = {this.state.discountCodeData} isEntitlePrice={this.state.isEntitlePrice}  fun_changeGoodsQuantity = {this.fun_changeGoodsQuantity} product={product} price={price} productName = {productName} available = {available} handleDeleteProduct={this.props.handleDeleteProduct} recalculate={this.recalculate} fun_handleDeleteProduct_emptyData={this.fun_handleDeleteProduct_emptyData} index={index}></RecommendationsCartItem>
            );
        });

        return(
            <div className="products-cart">
                { cartBlocks }
            </div>
        );
		}
		
		// syncProductsForOrderPageFromQuickAdd = (product) => {
		// 	let productsArr = this.state.productsArr;
		// 	let ind = productsArr.indexOf(product);
		// 	let productArrCopy = [];


		// 	if (ind < 0) {
		// 		productArrCopy = [...productsArr, product];
		// 	} else {
		// 		productArrCopy = [...productsArr.slice(0, ind), ...productsArr.slice(ind + 1)];
		// 	}
			
		// 	this.setState({ productsArr: productArrCopy });
		// }

		selectCountry = (val) => {
    this.setState({ country: val });
    }

    selectCountryShipping = (val) => {
      this.setState({ countryShipping: val });
    }

		selectRegion = (val) => {
			this.setState({ region: val });
		}

    selectRegionShipping = (val) => {
        this.setState({ regionShipping: val });
    }


    renderErrorMessage = () => {
        if (this.state.errorMessageShow) return <div className="user-paid error-confirm">{ this.state.errorMessage }</div>;
        else return null;
    }

    fun_showShowContactInformation(){
        this.setState({
            isShowContactInformation: !this.state.isShowContactInformation
        })
    }

    handleOptionChange = (e) => {
        this.setState({ useExistingCard: e.target.value === "existing" }, () => {
            if (this.state.useExistingCard) this.setState({ updateShippingAddressFromBilling: false });
            this.setState({ errorMessageShow: false, errorMessage: "" });

        });
    }

    handleOptionChangeShipping = (e) => {
        this.setState({ showShippingAddressSection: e.target.value === "showShipping" }, () => {
            console.log(this.state)
            this.setState({ errorMessageShow: false, errorMessage: "" });
        });
    }

    redeemGiftCardInFull() {
        const userId = localStorage.getItem("user_id");
        const url = '/api/used-discount-codes';
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': localStorage.getItem('auth_token')
            },
            body: JSON.stringify({
                "code": this.state.promoCodeSaved,
                "userId": userId
            })
        })
        .then((response) => {
            if (response.status >= 400 && response.status < 500) {
                throw new Error("Promo code was already redeemed.");
            } else if (response.status >= 500) {
                throw new Error("Server error.");
            } else {
                return;
            }
        })
        .catch((err) => {
            alert('There was an error redeeming your promo code: ' + err);
        });
    }

    handleSubmitContactInformation(e){
        e.preventDefault();
       let contactInformation_email = this.state.contactInformation_email;
       let contactInformation_lastName = this.state.contactInformation_lastName;
       let contactInformation_firstName = this.state.contactInformation_firstName;

        if(!contactInformation_lastName){
            alert('last Name cannot be empty');
            return false;
        }else if(!contactInformation_firstName){
            alert('first Name cannot be empty');
            return false;
        }else if(!contactInformation_email && contactInformation_email == ''){
            alert('emaill cannot be empty');
            return false;
        }else if(!isValidEmail(contactInformation_email)){
            alert('Email format error');
            return false;
        }else {
            let info_json = {
                contactInformation_email: contactInformation_email,
                contactInformation_lastName: contactInformation_lastName,
                contactInformation_firstName: contactInformation_firstName
            }
            localStorage.setItem("contactInformation_info", JSON.stringify(info_json));
            alert("Saved successfully");
            this.fun_showShowContactInformation();
        }
    }

    fun_setcontactInfoMatino_info(){
        if(!localStorage.getItem("auth_token")){
            let contactInformation_info = localStorage.getItem("contactInformation_info");
            if(isJSON(contactInformation_info)){
                let contactInformationJson = {};
                try {
                    contactInformationJson = JSON.parse(contactInformation_info);
                    this.setState({
                        contactInformation_email: contactInformationJson['contactInformation_email'],
                        contactInformation_lastName: contactInformationJson['contactInformation_lastName'],
                        contactInformation_firstName: contactInformationJson['contactInformation_firstName'],
                        isShowContactInformation:false,             
                    })
                } catch (error) {
                    contactInformationJson = {}
                }
            }
        }
       
    }


    render() {
  	return(
        <div className="checkout-zone">
            <form id="checkout-form" className="checkout-form" onSubmit={ this.handleSubmit } >
                <div className="checkout-zone-body">
                <div className="payment-confirm-top-title"><h3 className="title">Review order</h3></div>
                    <div className="payment-confirm-body">
                        <div className="payment-confirm-body-section payment-confirm-body-section-left">
                                <div className="payment-left-section section-up mobile">
                                    <div className="payment-top-title-icon">
                                        <div className="payment-top-text-left">
                                            <div className="payment-top-cart-text">Your cart</div>
                                            <img className="payment-top-icon" src="/images/cart.svg"></img>
                                        </div>
                                       <div className="payment-top-text-number">{this.props.cartGoodsCount()} items</div>
                                    </div>
                                    
                                    { this.renderCart() }
                                </div>

                                <div className="payment-left-section section-bottom might-bg">
                                    <h3 style={{fontWeight: 'normal'}}>You may also like</h3>
                                    { this.renderQuickAdd() }
                                </div>

                               

                            {
                                localStorage.getItem("auth_token") ? null :
                                <div className="payment-shipping-section-postion">
                                    <div className="payment-left-section section-up" style={{paddingBottom: 0}}>
                                        <div className="payment-left-section-mode" onClick={()=>{this.fun_showShowContactInformation()}}>
                                            <div className="payment-left-text">
                                                <h3>Contact Information</h3>
                                                <img src="/images/recommendations/contact_Information.svg"></img>
                                                <div className="half-look">
                                                    {this.state.contactInformation_firstName ?'('+ this.state.contactInformation_firstName+ ')' : '' }
                                                </div>
                                            </div>
                                            <i className={this.state.isShowContactInformation ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                        </div>

                                        <div style={this.state.isShowContactInformation ?  { display:"block"}:{ display:"none"}}>
                                            <div className="credit-card-radio" style={{display:"block"} }>
                                                <label className="credit-card-label" style={ {display: 'block'} }>
                                                    <input type="radio" value="existing" onClick={ this.handleOptionChange } onChange={ this.handleOptionChange } checked={ true } />
                                                    <span className="checkmark-custom"></span>
                                                    <div className="card-details-container">
                                                        <h4>Enter contact info</h4>
                                                    </div>
                                                </label>
                                            </div>
                                            <div className="contact-information-area">
                                                <div className="contact-information-area-first-last-name">
                                                    <input type="text" autoComplete="off" onChange={this.handleChangeAdddressInput} name="contactInformation_firstName" value={this.state.contactInformation_firstName} placeholder="First name" maxLength="50"></input>
                                                    <input type="text" autoComplete="off" onChange={this.handleChangeAdddressInput} name="contactInformation_lastName" value={this.state.contactInformation_lastName} placeholder="Last name" maxLength="50"></input>
                                                </div>
                                                <div className="contact-information-area-email"><input onChange={this.handleChangeAdddressInput} name="contactInformation_email" autoComplete="off" type="email" value={this.state.contactInformation_email} placeholder="Email address" maxLength="40"></input></div>
                                                <div className="contact-information-button">
                                                    <button onClick={ (e)=>{this.handleSubmitContactInformation(e)}  }>Save</button>
                                                </div>
                                            </div>                                     
                                        </div>

                                        <div className="payment-select-solid"></div>
                                    </div>
                                </div>
                            }
                            
                            <div className="payment-shipping-section-postion">
                              <div className="payment-left-section section-up" style={{paddingBottom: 0}}>
                                  <div className="payment-left-section-mode" onClick={()=>{this.fun_showPaymentConten()}}>
                                      <div className="payment-left-text">
                                          <h3>Payment</h3>
                                          <img src="/images/recommendations/Payment.svg"></img>
                                          <div className="half-look">
                                          {
                                            this.state.card.cardDigits ? '( ending ' + this.state.card.cardDigits +')' : ''
                                          }
                                          </div>
                                      </div>
                                      <i className={this.state.isShowPaymentConten ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                  </div>
                                  
                                  <div className="credit-card-radio" style={this.state.isShowPaymentConten ? {display:"block"} : {display:"none"} }>
                                      <label className="credit-card-label" value="existing" onClick={(e)=>{ this.setState({useExistingCard:true})  } } style={this.state.card.cardDigits ? {display: 'block'} : {display:'none'} }>
                                          <input type="radio" value="existing"  checked={ this.state.useExistingCard } />
                                          <span className="checkmark-custom"></span>
                                          <div className="card-details-container">
                                              <h4>Card on file </h4>
                                              <div className="card-details">
                                                  ( ending { this.state.card.cardDigits })
                                              </div>
                                          </div>
                                      </label>

                                      <label className="credit-card-label" onClick={ () => {  this.setState({useExistingCard:false}), ()=>{ animateScroll( document.getElementById("payment-block")   )  }   }    }>
                                          <input type="radio" value="new"  checked={ !this.state.useExistingCard } />
                                          <span className="checkmark-custom"></span>
                                          <h4 style={this.state.card.cardDigits ?  {display: 'block'} : {display:'none'} }>Replace with new card</h4>
                                          <h4 style={this.state.card.cardDigits ?  {display:'none'} : !this.state.useExistingCard ? {display: 'block'} :  {display: 'block',color:'#ffad94'}  }>Enter payment info</h4>
                                      </label>
                                  </div>
                                  <div id="gate-fee-checkout" style={this.state.isShowPaymentConten ? {display:"block"} : {display:"none"} }>
                                      <div id="payment-block" className={ !this.state.useExistingCard ? "checkout-block expanded" : "checkout-block"}  >
                                          { this.renderPaymentSection() }
                                          { this.renderErrorMessage() }
                                      </div>
                                  </div>
                                  <div className="payment-select-solid"></div>
                              </div>
                              <div className="payment-left-section section-down" style={{paddingBottom: 0}}>
                                  <div className="payment-left-section-mode" onClick={()=>{this.fun_showShippingConten()}}>
                                      <div className="payment-left-text">
                                          <h3 >Shipping</h3>
                                          <img src="/images/recommendations/Shipping.svg"></img>
                                          <div className="half-look">
                                            {this.state.shippingAddressName? '('+ this.state.shippingAddressStr+ ')' : '' }
                                          </div>
                                      </div>
                                      <i className={this.state.isShowShippingConten ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                  </div>

                                  <div className="credit-card-radio"  style={this.state.isShowShippingConten ? {display:"block"} : {display:"none"} }>
                                      <label className="credit-card-label" onClick={ this.handleOptionChangeShipping } style={this.state.shippingAddressName ?  {display:'block'} : {display: 'none'} }>
                                          <input type="radio" value="noShowShipping" onChange={ this.handleOptionChangeShipping } checked={ !this.state.showShippingAddressSection } />
                                          <span className="checkmark-custom"></span>
                                          <div className="credit-card-shipping-address">
                                              <h4>{ this.state.shippingAddressName }</h4>
                                              <div className="credit-card-shipping-address-str">
                                                  { this.state.shippingAddressStr }
                                              </div>
                                          </div>
                                      </label>
                                      <label className="credit-card-label" onClick={ () =>{ this.setState({ showShippingAddressSection:true })  } }>
                                          <input type="radio" value="showShipping" checked={ this.state.showShippingAddressSection } />
                                          <span className="checkmark-custom"></span>
                                          <h4 style={this.state.shippingAddressName ?  {display:'block'} : {display: 'none'} }>Ship to a new address</h4>
                                          <h4 style={this.state.shippingAddressName ?  {display:'none'} :  this.state.showShippingAddressSection ? {display: 'block'}  : {display: 'block',color:'#ffad94'} }>Enter shipping info</h4>
                                      </label>
                                  </div>
                                  <div id="gate-fee-checkout" style={this.state.isShowShippingConten ? {display:"block"} : {display:"none"} }>
                                      <div id="payment-block" className={ this.state.showShippingAddressSection ? "checkout-block expanded" : "checkout-block step-2"}  >
                                          { this.renderShippingSection() }
                                          { !!this.state.useExistingCard ? this.renderErrorMessage() : null }
                                      </div>
                                  </div>
                                  <div className="payment-select-solid"></div>
                              </div>
                            </div>
                            {/* end payment and shipping */}
                        </div>
                        <div className="payment-confirm-body-section payment-confirm-body-section-right">
                          
                             <div className="payment-right-section section-down">
    
                                <div className="promo-code-section">
                                    <div className="promo-input-container">
                                        <input className={ this.state.showPromoSuccessMessage && this.state.promoCodeError.length > 0 ? "promo-input active error" : this.state.promoCode !== '' ? "promo-input active" : "promo-input" }  autoComplete="off"  onChange={ this.handleChangeAdddressInput } onFocus={ () => { this.setState({ showPromoSuccessMessage: false, promoCodeError: '' }) } } name="promoCode" value={ this.state.promoCode } type="text" placeholder="Gift card or discount code" />
                                        <button className={ this.state.showPromoSuccessMessage && this.state.promoCodeError.length > 0 ? "promo-code active error" : this.state.promoCode !== '' ? "promo-code active" : "promo-code" } onClick={ this.checkIfPromoCodeExists } >
                                            Apply
                                            <Loader onClick={(e)=>{ e.stopPropagation()}} active={this.state.isApplyButton} inverted className={"but-load-style"}/>
                                        </button>
                                    </div>
                                    {
                                        this.state.showPromoSuccessMessage ?
                                            this.state.promoCodeError.length === 0 ?
                                                <div className="promo-success-message">Promo code { this.state.promoCodeSaved } redeemed!</div> :
                                                <div className="promo-success-message promo-error">{ this.state.promoCodeError }</div> 
                                        : null
                                    }
                                </div>
                                <div className="price">
                                    <div className="orig-price">
                                        <div className="label">Subtotal</div>
                                        <div className={((this.props.userPaidGateFee && this.props.amountPaidGateFee >0) ) || this.state.amountAvailableForDiscount > 0  && this.state.targetType != 'shipping_line'  ? "total-price" : "total-price no-strikethrough"}>{ " $" + parseFloat(this.state.price).toFixed(2) }</div>
                                    </div>

                                    {(this.props.eligibleForDiscount && this.props.amountPaidGateFee > 0 ) && this.props.amountPaidGateFee > 0 ? <div className="you-save">
                                        {
                                            this.props.amountPaidGateFee == 10 || this.props.amountPaidGateFee == 20 ? <div className="discount-offer">Purchase credit</div> :
                                            <div className="discount-offer">Consultation fee credit</div>
                                        }
                                        <div className="discount-amount">-${ parseFloat(this.props.amountPaidGateFee).toFixed(2) }</div>
                                    </div> : null}

                                    {(this.state.amountAvailableForDiscount) > 0 ? <div className="you-save">
                                        <div className="discount-offer">Promo code</div>
                                        <div className="discount-amount">{ this.calculatePromo() }</div>
                                    </div> : null}

                                    {
                                        this.state.discountPrice > 0 ?
                                        <div className="you-save">
                                            <div className="discount-offer">New subtotal </div>
                                            <div className="discount-amount">{ "$" + parseFloat(this.state.discountPrice).toFixed(2) }</div>
                                        </div>:<div></div>
                                    }

                                    <div className="you-save">
                                        <div className="discount-offer">Tax</div>
                                        <div className="discount-amount">{ "$" + parseFloat(this.state.tax).toFixed(2) }</div>
                                    </div>

                                    <div className="you-save">
                                        <div className="discount-offer">Shipping 
                                        {/* 这是原来的逻辑 */}
                                                                              
                                         {
                                            this.state.shippingAddressCountry === "Canada" ? <span className="shipping-messsage"> (International shipping)</span> :
                                            parseFloat(this.state.shippingRate) > 0 ? <span className="shipping-messsage"> (free shipping on orders in the US over $50)</span> : null
                                        }

                                        {/* 因为冠状病毒，所有的客户提供免运费，国际shipping除外，我们依旧charge他们$15. */}
                                        {/* {
                                            this.state.shippingAddressCountry === "Canada" ? <span className="shipping-messsage"> (International shipping)</span> : null
                                        } */}
                                        </div>

                                         {/* <div className="discount-amount">{ "$" + parseFloat(this.state.shippingRate).toFixed(2) } */}
                                         {
                                            this.state.targetType == 'shipping_line' && this.state.originalShipping > 0 ? <div className="discount-amount lineThrough-style">{ "$" + parseFloat(this.state.originalShipping).toFixed(2) }</div>
                                            : <div className="discount-amount">{ "$" + parseFloat(this.state.shippingRate).toFixed(2) }</div>
                                         }


                                    </div>
                               
                                </div>

                                        

                            </div>
                          
                        </div>

                        <div className="crat-bottom-price-confirm-mode">
                            <div className="discount-price" style={{marginTop:'4px'}}>
                                <div className="label">Total</div>
                                <div className="total-price">
                                 {/* {
                                   parseFloat(this.state.price).toFixed(2) > (this.calculateFinalPrice() * 1) ? <span className="crat-bottom-subtotal">{ " $" + parseFloat(this.state.price).toFixed(2) }</span>
                                   : <span></span>
                                 } */}
                                $ { this.calculateFinalPrice() }
                                </div>
                            </div>
                            <button disabled={ this.state.disablePurchaseButton } className="pay-checkout-button" style={{marginTop:'10px',paddingTop:'10px',paddingBottom:'10px'}}>
                                <img className="prom-confirm-button" src="/images/cart_white.svg"/>
                                Place order now
                                <i className="fa fa-spinner fa-pulse pay-checkout-load" style={this.state.isCheckoutButton ? {display:'block'}:{display:'none'}}></i>
                            </button>
                        </div>
                    </div>
                     <div className="mobil-checkout-span"></div>                   
                   
                    </div>
                </form>

               
               
        </div>  

       );
    }
}

function mapStateToProps(state) {
	const { helloava } = state;
    const { cartGoodsCount, cartGoodsList, cartPriceSum } = helloava.myCart;
    return {cartGoodsCount, cartGoodsList, cartPriceSum };
}

function mapDispatchToProps(dispatch) {
    return {
        getUserCartData: () => dispatch(getUserCartData()),
        fun_deleteAllCartGoodsData: () => dispatch(fun_deleteAllCartGoodsData()),
        addOrDeleteCartGoodsData: (productObj,actionType) => dispatch(addOrDeleteCartGoodsData(productObj,actionType))
    };
}

export default connect(mapStateToProps,mapDispatchToProps)(injectStripe(RecommendationsCheckout));



// WEBPACK FOOTER //
// ./src/views/recommendations/RecommendationsCheckout.js